import * as React from 'react';
import { Container, Grid, Header } from 'semantic-ui-react';
import { features } from './featuresList';
import './style.css';
import { PlanSubscriptionView } from 'components/presentational/views/PlanSubscription';

export interface IFeaturesTableProps {
  feature: string;
}

export interface IFeaturesProps {
  signInSignUp: (ctaButtonText) => void;
}

const Table: React.SFC<IFeaturesTableProps> = ({ feature }) => {
  const mapToTableRows = (content: React.ReactNode, index: number) => (
    <tr key={index}>
      <td>{content}</td>
    </tr>
  );

  return (
    <Grid.Column tablet={9} computer={8} largeScreen={7}>
      <table className="landing-features-table">
        <thead>
          <tr>
            <th>{feature.toLocaleUpperCase()}</th>
          </tr>
        </thead>
        <tbody>
          {features[feature].map(mapToTableRows)}
        </tbody>
      </table>
    </Grid.Column>
  );
}

export const Features: React.SFC<IFeaturesProps> = ({ signInSignUp }) => {
  const mapToTable = (feature: string, index: number) => (
    <Table key={index} feature={feature} />
  );
  const ctaButtonText = "Get It Now";
  return (
    <React.Fragment>
      <div className="landing-features">
        <Container>
          <div className="landing-features__background">
            <div className="landing-features__block">
              <Header as="h2" className="landing-features__title">
                <span>Beta Features</span>
              </Header>
              <p className="description">
                Your beta app will be regularly updated with new features{' '}
                until the official release of your desired language,{' '}
                at which point your subscription billing will begin.
            </p>
            </div>
            <Grid stackable={true} centered={true}>
              <Grid.Row>
                {Object.keys(features).map(mapToTable)}
              </Grid.Row>
            </Grid>
          </div>
        </Container>
      </div>
      <div className="landing-feature-alt">
        <Container style={{ width: 600 }}>
          <div className="landing-features__block">
            <Header as="h2" className="landing-features__title">
              <span>See The Demo</span>
            </Header>
            <iframe className="video" src="https://www.youtube.com/embed/ilGud3U8Nms?rel=0" allow="accelerometer; autoplay; encrypted-media; gyroscope;" frameBorder="0" />
          </div>
        </Container>
      </div>
      <div className="landing-features">
        <PlanSubscriptionView onSubscribe={(planId) => signInSignUp(ctaButtonText)} planButtonText={ctaButtonText} isAllowRedeemCoupone={false} />
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/presentational/views/Landing/sections/Features/index.tsx